import { defineMessages } from 'react-intl';

export default defineMessages({
  noAbsencesYet: {
    id: 'app.containers.AbsenceList.noAbsencesYet',
    defaultMessage: 'No absences are planned at this time.',
  },
  absence: {
    id: 'app.containers.AbsenceList.absence',
    defaultMessage: '{from} - {to}',
  },
  collidesWithApplications: {
    id: 'app.containers.AbsenceList.collidesWithApplications',
    defaultMessage:
      'There are shift applications during this time. Please revoke them, if you cannot attend.',
  },
  removeAbsence: {
    id: 'app.containers.AbsenceList.removeAbsence',
    defaultMessage: 'Revoke absence',
  },
  addAbsence: {
    id: 'app.containers.AbsenceList.addAbsence',
    defaultMessage: 'Add absence',
  },
  emptyStateText: {
    id: 'app.containers.AbsenceList.emptyStateText',
    defaultMessage:
      'Manage in which time frames you are not available for service. During the times you are not available, you will not be applied automatically according to your availability.',
  },
  deleteSuccess: {
    id: 'app.containers.AbsenceList.deleteSuccess',
    defaultMessage: 'Absence revoked successfully',
  },
  deleteFailure: {
    id: 'app.containers.AbsenceList.deleteFailure',
    defaultMessage: 'Error. Failed to revoke absence.',
  },
  deleteConfirmTitle: {
    id: 'app.containers.AbsenceList.deleteConfirmTitle',
    defaultMessage: 'Revoke absence',
  },
  deleteConfirmText: {
    id: 'app.containers.AbsenceList.deleteConfirmText',
    defaultMessage: 'Revoke absence from {from} to {to}?',
  },
  deleteConfirmDelete: {
    id: 'app.containers.AbsenceList.deleteConfirmDelete',
    defaultMessage: 'Yes, revoke absence',
  },
  deleteConfirmCancel: {
    id: 'app.containers.AbsenceList.deleteConfirmCancel',
    defaultMessage: 'No, keep absence',
  },
});
